<template>
  <footer class="main-footer">
    <div class="footer-container">
      <div class="footer-brand">
        <img src="@/assets/logos/logo-branco.png" alt="Logo EducaMais" class="footer-logo" />
        <p class="footer-slogan">Transformando o aprendizado com tecnologia e inovação.</p>
      </div>

      <div class="footer-links">
        <div class="footer-column">
          <h3>Plataforma</h3>
          <router-link to="/home">Início</router-link>
          <router-link to="/library">Biblioteca</router-link>
          <router-link to="/profile">Perfil</router-link>
        </div>
        <div class="footer-column">
          <h3>Suporte</h3>
          <router-link to="/help">Central de Ajuda</router-link>
          <a href="#">Termos de Uso</a>
          <a href="#">Política de Privacidade</a>
        </div>
      </div>

      <div class="footer-social">
        <h3>Siga-nos</h3>
        <div class="social-icons">
          <a href="https://www.instagram.com/unimaisedu?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" aria-label="Instagram"><i class="fa-brands fa-instagram"></i></a>
          <a href="https://www.linkedin.com/school/unimais/jobs/" aria-label="LinkedIn"><i class="fa-brands fa-linkedin-in"></i></a>
          <a href="https://www.youtube.com/@Educamaislive" aria-label="YouTube"><i class="fa-brands fa-youtube"></i></a>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <p>&copy; {{ currentYear }} Projeto Asas. Todos os direitos reservados.</p>
    </div>
  </footer>
</template>

<script>
import '@/styles/Footer.css';

export default {
  name: 'Footer',
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
}
</script>
